const metadataRecord = (metadata?: unknown): Record<string, unknown> => {
  if (!metadata) return {};
  if (typeof metadata === 'string') {
    try {
      const parsed = JSON.parse(metadata) as unknown;
      return parsed && typeof parsed === 'object'
        ? (parsed as Record<string, unknown>)
        : {};
    } catch {
      return {};
    }
  }
  return metadata && typeof metadata === 'object'
    ? (metadata as Record<string, unknown>)
    : {};
};

export type ParticipantClientKind = 'mobile_app' | 'mobile_web' | '';

export const participantClientKind = (
  metadata?: unknown,
): ParticipantClientKind => {
  const value = String(metadataRecord(metadata).geoescala_client || '')
    .trim()
    .toLowerCase();
  if (value === 'mobile_app' || value === 'mobile_web') return value;
  return '';
};

